<template>
  <div>
    <div class="module-result-content">
      <div class="result-content">
        <el-table
            :data="tableData.list"
            style="width: 100%"
            height='calc(100vh - 120px)'
        >
          <el-table-column
              prop="startTime"
              label="日期"
              width="200">
            <template scope="scope">
              <div>{{new Date(scope.row.createTime).Format('yyyy-MM-dd hh:mm:ss')}}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="name"
              label="文件名称"
              min-width="200"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              prop="source"
              label="任务来源"
              width="120"
              align="center"
          >
            <template scope="scope">
              <div>{{scope.row.source | sourceFilter}}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="status"
              label="状态"
              width="120"
              align="center"
          >
            <template scope="scope">
              <div v-if="scope.row.status === 'RUNNING'">导入中</div>
              <div v-if="scope.row.status === 'FINISHED'">已完成</div>
              <div v-if="scope.row.status === 'WAITING'">等待中</div>
            </template>
          </el-table-column>
          <el-table-column
              label="结果"
              width="150"
              align="center"
          >
            <template scope="scope">
              <div>
                <span v-if="scope.row.successNum!==null">成功{{scope.row.successNum}},</span>
                <span v-else>成功--,</span>
                <span v-if="scope.row.errorNum!==null">失败{{scope.row.errorNum}}</span>
                <span v-else>失败--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="上传失败原因"
              width="200"
              align="center"
          >
            <template scope="scope">
              <el-popover
                  placement="left"
                  width="=300"
                  trigger="hover"
                  v-if="scope.row.errorTips!==null"
              >
                <div v-if="scope.row.errorTips!==null">
                  <div
                      v-for="(item,index) in scope.row.errorTips"
                      :key="index"
                      style="padding: 4px 0"
                  >
                    {{item}}
                  </div>
                </div>
                  <div class="item-bot" slot="reference" style="height: 40px;align-items: center;width: 180px">
                    <div v-if="scope.row.errorTips!==null">
                      <div
                          v-for="(item,index) in scope.row.errorTips"
                          :key="index"
                      >
                        <div style="width: 160px;text-overflow: ellipsis;overflow:hidden;white-space: nowrap;cursor: pointer;line-height: 40px"> {{item}}</div>
                      </div>
                    </div>
                  </div>
              </el-popover>
              <div v-if="scope.row.errorTips===null">无</div>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="130"
              align="center"
          >
            <template slot-scope="scope">
              <el-button
                  type="text"
                  v-if="scope.row.errorFileUrl!==null"
              >
                <a  style="text-decoration: none;color: #409eff" :href="scope.row.errorFileUrl" target="_blank">下载失败数据</a>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
    <el-pagination
        style="position: absolute;bottom: 5px;right: 20px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total">
    </el-pagination>
  </div>

</template>

<script>
export default {
  name: "upLoad",
  data(){
    return{
      tableData:{
        list:[],
        total:0
      },
      currentPage:1,
      pageSize:20,
    }
  },
  filters:{
    sourceFilter(value)
    {
      if(value === 'WORK_ORDER_SYSTEM')
        return '工单导入'
    }
  },
  mounted() {
    this.getUploadList()
  },
  methods:{
    //获取上传中心列表
    getUploadList(){
      let url='api/task/order-upload?num='+this.pageSize+'&page='+this.currentPage
      this.$http.get(url).then(res=>{
        console.log(res)
        this.tableData.list =res.data.data.content
        this.tableData.total =res.data.data.totalElements
      })
    },
    downLoad(){},
    handleSizeChange(value){
      this.pageSize=value
      this.getUploadList()
    },
    handleCurrentChange(value){
      this.currentPage=value
      this.getUploadList()
    }
  },

}
</script>

<style  lang="less">
.module-result-content {
  flex: 1;
  display: flex;
  flex-direction: column;

  .result-content {
    flex: 1;
    position: relative;
    .el-table {
      width: 100%;
      position: absolute;
      overflow: hidden;
    }

  }
  .el-table__row{
    height: 64px;
    line-height: 64px;
  }
}
</style>